import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  category: FunctionCategory.MATH,
  params: [],
  name: 'PI',
  description: 'Mathematical constant π (pi).',
  shortDescription: 'π (pi)',
} satisfies AnalysisFunction;
